<div class="flex flex-row justify-between items-start mt-1">
  <h2>{{ "login_credential" | i18n }}</h2>
  <mat-icon class="pointer" *ngIf="!!dialogRef.id" (click)="onClose()">close</mat-icon>
</div>

<mat-card class="manage-credentials mat-custom-card mat-custom-card-shadow">
  <div class="flex flex-col lg:flex-row justify-around mt-1 mb-1">
    <mat-form-field class="field-container full-width">
      <mat-label>{{ "email_account" | i18n | titlecase }} </mat-label>
      <input matInput [disabled]="true" [value]="email" />
    </mat-form-field>
  </div>

  <div class="flex flex-col lg:flex-row justify-center items-center lg:items-baseline gap-[2em] mt-1 mb-1">
    <button mat-flat-button class="ald-mat-button primary" (click)="onChangePasswordTrigger()">
      {{ "change_password" | i18n | uppercase }}
    </button>
    <button mat-flat-button class="ald-mat-button primary" (click)="onChangeMailTrigger()">
      {{ "change_email" | i18n | uppercase }}
    </button>
  </div>
</mat-card>